import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'listFilter'
})
export class ListFilterPipe implements PipeTransform {

  transform(list: any[], filter: any): any {
    if (!list || !filter) {
      return list;
    }

    // filter = filter.toLowerCase();
    return list.filter(item => item[Object.keys(filter)[0]]?.toLowerCase().includes(filter[Object.keys(filter)[0]]?.toLowerCase()));
  }

}
